import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Globals } from 'app/_globals';
import { DashboardWorkOrderGraphData } from 'app/_models/dashboard-work-order-graph-data.model';

@Component({
  selector: 'work-order-modal',
  templateUrl: './work-order-modal.component.html'
})
export class WorkOrderModalComponent implements OnInit {
  @Input() graphData: DashboardWorkOrderGraphData;
  @Input() showSite: boolean = false;
  private routeRole: string;

  public title: string;

  public cols: any[];
  public rows: any[];

  constructor(
    private activeModal: NgbActiveModal,
    private router: Router,
    globals: Globals,
  ) {
    this.routeRole = globals.user.routeRole;
  }

  ngOnInit() {
    this.title = `${this.graphData.value} ${this.graphData.label}`;
    this.rows = this.graphData.data.map(data => {
      return {
        ...data,
        wrkId: 'WRK ' + data.id,
        assetName: data.assetName ? data.assetName : data.asset.name,
        siteName: data.siteName ? data.siteName : data.asset.site.name,
        siteId: data.siteId ? data.siteId : data.asset.site.id,
      };
    }).sort((a, b) => {
      return new Date(b.lastModifiedDate).getTime() - new Date(a.lastModifiedDate).getTime();
    });

    if (this.showSite) {
      this.cols = [
        { field: 'wrkId', header: 'Work Order' },
        { field: 'description', header: 'Description' },
        { field: 'siteName', header: 'Site' },
        { field: 'assetName', header: 'Asset' },
        { field: 'createdDate', header: 'Created Date', type: 'date' },
        { field: 'lastModifiedDate', header: 'Last Updated', type: 'date' },
        { type: 'link', linkText: 'view' },
      ];
    } else {
      this.cols = [
        { field: 'wrkId', header: 'Work Order' },
        { field: 'description', header: 'Description' },
        { field: 'assetName', header: 'Asset' },
        { field: 'createdDate', header: 'Created Date', type: 'date' },
        { field: 'lastModifiedDate', header: 'Last Updated', type: 'date' },
        { type: 'link', linkText: 'view' },
      ];
    }
  }

  public closeModal() {
    this.activeModal.dismiss();
  }

  public goToWorkOrder(workOrder) {
    this.activeModal.dismiss();
    this.router.navigate(['/' + this.routeRole + '/sites/' + workOrder.siteId + '/work-orders/' + workOrder.id]);
  }
}
